<template>
  <v-layout row justify-center>
    <v-dialog v-model="newUserDialog" max-width="630px"
      transition="dialog-bottom-transition" @keydown.esc="newUserDialog = false">
      <v-card>
        <v-toolbar color="blue-grey lighten-5">
          <v-spacer></v-spacer>
          <v-toolbar-title class="text-xs-center">CADASTRO  NOVO ALUNO</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="newUserDialog = false">
            <v-icon>fal fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6>
                <v-text-field label="Nome" v-model="user.first_name" required></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="Sobrenome" v-model="user.last_name" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field placeholder="Informe o email do aluno:" label="Email" v-model="user.email" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select :items="usersType" item-text="name" item-value="value"
                  label="Tipo de usuário" v-model="user.roles[0]" append-icon="fal fa-chevron-down" required
                ></v-select>
              </v-flex>
              <!-- <v-flex xs12>
                <v-select :items="plans" item-text="name" item-value="value"
                  label="Plano" v-model="user.plan" append-icon="fal fa-chevron-down" required
                ></v-select>
              </v-flex> -->
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.stop.prevent="createLogin()" round large depressed color="success"
            :loading="loadingRequest">
            Cadastrar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'
import { Auth } from 'aws-amplify'

export default {
  name: 'AdminDialogNewUser',
  data: () => ({
    newUserDialog: false,
    loadingRequest: false,
    user: {
      first_name: '',
      last_name: '',
      email: '',
      plan: '',
      roles: ['user'],
      username: ''
    },
    plans: [
      { name: 'Mensal', value: 'monthly' },
      { name: 'Trimestral', value: 'quarterly' }
    ],
    usersType: [
      { name: 'Aluno', value: 'user' },
      { name: 'Admin', value: 'admin' }
    ]
  }),

  methods: {
    createUser (id) {
      this.loadingRequest = true

      if (this.user && this.user.email) {
        this.user.username = this.user.email
      }

      if (id) this.user._id = id

      return new Promise((resolve, reject) => {
        // eslint-disable-next-line
        axios.post(API.users, this.user).then(response => {
          this.newUserDialog = false
          EventBus.$emit('loadUsers')
          return resolve(response)
        }).catch(errors => {
          this.loadingRequest = false
          EventBus.$emit('showSnackbar', { message: 'Erro ao criar um usuário', color: 'error' })
          return reject(errors)
        })
      })
    },

    createLogin () {
      this.loadingRequest = true
      const tempPass = Math.random().toString(36).slice(-8)

      Auth.signUp({
        username: this.user.email,
        password: tempPass,
        attributes: {
          email: this.user.email,
          'custom:firstName': this.user.first_name,
          'custom:last_name': this.user.last_name,
          'custom:roles': JSON.stringify(this.user.roles),
          'custom:temp_pass': tempPass
        }
      }).then(async (response) => {
        await this.createUser(response.userSub)

        this.newUserDialog = false
        EventBus.$emit('showSnackbar', {
          message: 'Aluno criado com sucesso! Ele receberá um email para completar o cadastro.',
          color: 'success'
        })
      }).catch(errors => {
        console.log(errors)
        this.loadingRequest = false
        this.newUserDialog = false
        EventBus.$emit('showSnackbar', { message: 'Erro ao criar um usuário', color: 'error' })
      })
    }
  },

  beforeDestroy () {
    EventBus.$off('newUserDialog')
  },

  mounted () {
    EventBus.$on('newUserDialog', data => {
      this.newUserDialog = data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminDialogNewUser.vue